import { render, staticRenderFns } from "./Send-Mail.vue?vue&type=template&id=aba7eeca&scoped=true"
import script from "./Send-Mail.vue?vue&type=script&lang=js"
export * from "./Send-Mail.vue?vue&type=script&lang=js"
import style0 from "./Send-Mail.vue?vue&type=style&index=0&id=aba7eeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba7eeca",
  null
  
)

export default component.exports